import React from 'react';
import { Table } from '../../../base/Table';
import { canRegister } from '../../../../services/acceptanceRegistration';
import { useUserAcceptanceRole } from '../../../../shared/hooks/userAcceptanceRole';
import Date from './Date';
import Register from './Register';
import InteractiveDate from './InteractiveDate';

const RecordCell = ({ record, column, row }) => {
  return (
    <Table.BodyCell column={column} row={row}>
      <Content record={record} />
    </Table.BodyCell>
  );
};

export default RecordCell;

function Content({ record }) {
  const role = useUserAcceptanceRole();

  const { acceptanceDate, acceptanceTime } = record.recordInfo ?? {};

  if (role.isReader) {
    return <Date date={acceptanceDate} time={acceptanceTime} />;
  }

  if (canRegister(record)) {
    return <Register record={record} />;
  }

  if (acceptanceDate || acceptanceTime) {
    return <DateComponent record={record} />;
  }

  return null;
}

function DateComponent({ record }) {
  const {
    recordInfo: {
      acceptanceStatusAddressLifeCycle,
      acceptanceDate,
      acceptanceTime,
    },
  } = record;

  if (acceptanceStatusAddressLifeCycle) {
    return <Date date={acceptanceDate} time={acceptanceTime} />;
  }

  return <InteractiveDate record={record} />;
}
